/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Codeeditor_Press_To_Save_SuffixInputs */



/**
* | output |
* | --- |
* | "to close" |
*
* @param {Spaces_Codeeditor_Press_To_Save_SuffixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_codeeditor_press_to_save_suffix = /** @type {((inputs?: Spaces_Codeeditor_Press_To_Save_SuffixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Codeeditor_Press_To_Save_SuffixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("um zu schließen")
	return /** @type {LocalizedString} */ ("to close")
});